var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFamily(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.88C7 3.47 6.16 2 4.35 2 2.52 2 1.67 3.47 1.67 4.88S.17 7.47.17 7.47s1.68 1.3 2.83.18c.08-.08.15-.18.22-.28a2.36 2.36 0 0 0 2.22 0l.24.28c1.15 1.13 2.82-.19 2.82-.19S7 6.29 7 4.88zm4.48 3.37h-.18a4.48 4.48 0 0 0-4.53 4.43v.12c0 .66.55 1.2 1.23 1.2h6.78c.67 0 1.22-.54 1.22-1.2v-.11a4.48 4.48 0 0 0-4.52-4.44zm2.4-3.45a2.47 2.47 0 0 0-2.5-2.45A2.48 2.48 0 0 0 8.89 4.8a2.47 2.47 0 0 0 2.5 2.44c1.38 0 2.5-1.1 2.5-2.44zm-7.98 8v-.11c0-1.2.4-2.32 1.1-3.2a4.37 4.37 0 0 0-2.66-.9A4.3 4.3 0 0 0 0 12.85C0 13.48.53 14 1.17 14H6.3c-.25-.34-.4-.75-.4-1.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFamily);
export default ForwardRef;